import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { LoginService } from '../../login/login.service';
import { TransactionsRevisionsReasonsService } from '../../transactions/_services/transactions-revision-reasons.service';
import { TransactionRevisionReason } from '../../transactions/_types/transaction-revision-reason';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-transactions-revision-reasons-detail',
    templateUrl: './transactions-revision-reasons-detail.component.html',
    styleUrls: ['./transactions-revision-reasons-detail.component.scss'],
    standalone: false
})
export class TransactionsRevisionReasonsDetailComponent {
  public transactionRevisionReasonFormGroup!: RxFormGroup;

  public transactionRevisionReason: TransactionRevisionReason = new TransactionRevisionReason();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private transactionsRevisionsReasonsService: TransactionsRevisionsReasonsService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) {

    this.transactionRevisionReasonFormGroup = this.formBuilder.formGroup<TransactionRevisionReason>(this.transactionRevisionReason) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de Razón de revisión de transacción");
    this.topbarService.addBreadcrumb("Razón de revisión", "/transactionsRevisionReasons");
    let id = this.config.data.id;
   // let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadtransactionRevisionReason(id);
    }
    this.allowWrite = this.loginService.hasPermission("TRANSACTIONS_REVISION_REASONS.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRANSACTIONS_REVISION_REASONS.DELETE");


  }

  async loadtransactionRevisionReason(id: string) {
    this.transactionRevisionReason = await firstValueFrom(this.transactionsRevisionsReasonsService.get(id));
    this.transactionRevisionReasonFormGroup.patchValue(this.transactionRevisionReason);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.transactionRevisionReasonFormGroup);
    if (valid) {
      this.transactionRevisionReason = Object.assign(this.transactionRevisionReason, this.transactionRevisionReasonFormGroup.value);
      
      let transactionRevisionReason = await firstValueFrom(this.transactionsRevisionsReasonsService.save(this.transactionRevisionReason));

      this.messageService.add({ closable: true, severity: 'success', summary: "Razón guardada correctamente." });

      
      this.router.navigate(['transactionsRevisionReasons']);
            

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la razón de revisión "+this.transactionRevisionReason.name+"?",
      header: "Eliminar razón",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.transactionsRevisionsReasonsService.delete(this.transactionRevisionReason.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de vehículo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }
/*
  cancel() {
    this.router.navigate(['transactionsRevisionReasons']);
  }
  */
  cancel() {
    this.dynamicDialogRef.close();
  }

}
